import React from 'react';
import { mergeStyles } from '@cian/utils';

import { EPropertyGuidesGroups } from '../../../app/helpers/ab_mainpage_property_guides';
import { useMediaQuery } from './utils/useMediaQuery';
import { SimplifiedCards } from './SimplifiedCards';
import { GlamorousCards } from './GlamorousCards';

import styles from './PropertyGuides.css';

interface IProps {
  experiment: EPropertyGuidesGroups;
}

export const PropertyGuides = ({ experiment }: IProps) => {
  const { className: rootClassName } = mergeStyles('cg-container-fluid-xs', styles['container']);
  const device = useMediaQuery();

  return (
    <div className={rootClassName}>
      <h2 className={styles['title']}>Полезные сервисы ЦИАН</h2>
      {experiment === EPropertyGuidesGroups.Simple && <SimplifiedCards device={device} />}
      {experiment === EPropertyGuidesGroups.Glamour && <GlamorousCards device={device} />}
    </div>
  );
};
